import { render, staticRenderFns } from "./WarningPerson.vue?vue&type=template&id=1a7e57f7&scoped=true"
import script from "./WarningPerson.vue?vue&type=script&lang=js"
export * from "./WarningPerson.vue?vue&type=script&lang=js"
import style0 from "./WarningPerson.vue?vue&type=style&index=0&id=1a7e57f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7e57f7",
  null
  
)

export default component.exports